import { SupportedLocale } from '@afterpay/types'

// TO DO: Add SupportedLocale enums to types
export const billingAddressFFFallback = (locale: SupportedLocale | undefined): boolean => locale !== 'en-AU' && locale !== 'en-NZ'
